import LiquidText from '../components/LiquidText';
import EquipamentoProdutoQuimicoModal from '../components/EquipamentoProdutoQuimicoModal';
import { codigoEquipamento, dataVerificacaoEquipamento } from '../utils/codigoEquipamento';
import { OrcamentoIcon } from '../components/OrcamentoUI';
import { LiquidDialog, useLiquidFeedback } from '../components/LiquidUI';
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import DocumentosCertificacao from './DocumentosCertificacao';
import ChecklistDL50, { checklistConforme, checklistPara, tiposEpi } from '../components/ChecklistDL50';
import DL50LoteModal from '../components/DL50LoteModal';
import { descarregarBlob } from '../utils/abrirFicheiro';
import './Equipamentos.css';
import RmmEquipamentosModal from '../components/RmmEquipamentosModal';
import ProdutosQuimicosPainel from '../components/ProdutosQuimicosPainel';
import './ProdutosQuimicos.css';

const FORM_VAZIO = {
    nome: '',
    categoria: 'equipamento',
    trabalhador_id: '',
    tipo: '',
    marca: '',
    modelo: '',
    n_serie: '',
    matricula: '',
    qr_etiquetas: 1,
    data_inspecao: '',
    data_revisao: '',
    data_fim_certificacao: '',
    proprio: true,
    ano: '',
    manual_instrucoes: true,
    certificacoes_data: '',
    certificacoes_horas: '',
    certificado_tipo: '',
    homologacao: '',
    marcacao_ce: true,
    parecer_favoravel: false,
    certificado_seguro: '',
    contra_terceiros: false,
    providentes_renda: '',
    certificado_formacao_en12645: '',
    formacao_horas: '',
    horas_utilizacao: '',
    manutencao: '',
    praticas_reais: '',
    verificacao_sifo_siro: false,
    verificacao_data: '',
    periodicidade: '',
    observacoes: '',
    empresa_responsavel: 'SPROD, LDA',
    certificado_bom_funcionamento: false,
    ultima_calibracao: '',
    proxima_calibracao: '',
    ultima_revisao_data: '',
    ultima_revisao_horas: '',
    proxima_revisao_data: '',
    proxima_revisao_horas: '',
    dl50_ultima_verificacao: '',
    dl50_proxima_verificacao: '',
    dl50_resultado: ''
};

// Categoria da ficha. As ferramentas e os RMM também entram pelo telemóvel
// (Equipamentos no menu mobile); as fichas anteriores ficaram 'equipamento'.
const CATEGORIAS = {
    equipamento: { label: 'Equipamento', plural: 'Equipamentos', icone: '🚜', bg: '#edf2f7', fg: '#4a5568' },
    ferramenta: { label: 'Ferramenta', plural: 'Ferramentas', icone: '🔧', bg: '#ebf8ff', fg: '#2b6cb0' },
    rmm: { label: 'RMM', plural: 'RMM', icone: '📏', bg: '#faf5ff', fg: '#6b46c1' },
};
const categoriaDe = (eq) => (CATEGORIAS[eq.categoria] ? eq.categoria : 'equipamento');

// Por etiquetar: fichas com registo de quem as carregou cuja etiqueta QR nunca
// foi impressa. As anteriores a esse registo não têm histórico de impressão (e
// muitas já estão etiquetadas), por isso ficam de fora.
const porEtiquetar = (eq) => !eq.qr_impresso_em && !!eq.registado_por_nome;

const fmtDataHora = (v) => (v
    ? new Date(v).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '');

// A categoria mostra-se já como seletor: uma ficha mal catalogada passa para o
// sítio certo (equipamento ↔ ferramenta ↔ RMM) sem abrir o formulário.
const SeletorCategoria = ({ eq, onMudar }) => {
    const cat = categoriaDe(eq);
    const c = CATEGORIAS[cat];
    return (
        <select className="eq-category-select" value={cat} onChange={e => onMudar(eq, e.target.value)}
            aria-label={`Categoria de ${eq.nome}`} title="Mudar a categoria"
            style={{ padding: '3px 6px', borderRadius: 12, border: `1px solid ${c.fg}55`, background: c.bg, color: c.fg, fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer' }}>
            {Object.entries(CATEGORIAS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
            <option value="produto_quimico">Produto químico</option>
        </select>
    );
};
/* Etiquetas QR em lote. Três âmbitos: as fichas que estão à vista (com os
   filtros), todas as ativas, ou as de uma pessoa — é como se pedem as etiquetas
   de quem vai levar as ferramentas. O formato por omissão é a etiquetadora
   50×25 mm; a folha A4 serve para recortar quando ela não está à mão. */
const QrLoteModal = ({ filtrados, trabalhadores, equipamentos, apenasFiltrados = false, onImprimir, onFechar }) => {
    const [ambito, setAmbito] = useState('filtrados');
    const [pessoa, setPessoa] = useState('');
    const [formato, setFormato] = useState('etiqueta');
    const [categoria, setCategoria] = useState('todas');

    const daPessoa = equipamentos.filter(e => String(e.trabalhador_id) === String(pessoa)
        && e.ativo !== false
        && (categoria === 'todas' || categoriaDe(e) === categoria));
    const todas = equipamentos.filter(e => e.ativo !== false
        && (categoria === 'todas' || categoriaDe(e) === categoria));
    const quantos = ambito === 'filtrados' ? filtrados.length : ambito === 'pessoa' ? daPessoa.length : todas.length;
    const pronto = ambito !== 'pessoa' || !!pessoa;

    const imprimir = () => {
        if (ambito === 'filtrados') onImprimir(filtrados.map(e => e.id), formato);
        else if (ambito === 'pessoa') onImprimir({ trabalhador_id: pessoa, categoria: categoria === 'todas' ? null : categoria }, formato);
        else onImprimir({ categoria: categoria === 'todas' ? null : categoria }, formato);
        onFechar();
    };

    const opcao = (valor, titulo, descricao) => (
        <label key={valor} style={{
            display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 12px', cursor: 'pointer',
            border: `1px solid ${ambito === valor ? '#3182ce' : '#e2e8f0'}`, borderRadius: 8,
            background: ambito === valor ? '#ebf8ff' : '#fff',
        }}>
            <input type="radio" name="qr-ambito" checked={ambito === valor} onChange={() => setAmbito(valor)} style={{ marginTop: 3 }} />
            <span>
                <span style={{ fontWeight: 600, display: 'block' }}><LiquidText>{titulo}</LiquidText></span>
                <span style={{ fontSize: '0.8rem', color: '#64748b' }}>{descricao}</span>
            </span>
        </label>
    );

    return (
        <LiquidDialog onClose={onFechar} onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '50px 16px', overflowY: 'auto' }}>
            <div data-liquid-surface="true" onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 14, padding: 22, width: '100%', maxWidth: 520, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' }}>
                <h3 style={{ margin: '0 0 4px' }}><OrcamentoIcon name="tag" fallback="🏷️" /> Imprimir etiquetas QR</h3>
                <p style={{ margin: '0 0 16px', color: '#64748b', fontSize: '0.85rem' }}>
                    Uma etiqueta por página (a etiquetadora faz o resto). As fichas com mais
                    de uma peça repetem o mesmo QR tantas vezes quantas as etiquetas configuradas.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                    {opcao('filtrados', `As ${filtrados.length} da lista`, 'O que está à vista, com a pesquisa e os filtros aplicados')}
                    {!apenasFiltrados && opcao('todos', 'Todos os equipamentos', 'Todas as fichas ativas')}
                    {!apenasFiltrados && opcao('pessoa', 'Por pessoa afeta', 'As fichas que estão com um trabalhador')}
                </div>

                {ambito === 'pessoa' && (
                    <select value={pessoa} onChange={e => setPessoa(e.target.value)}
                        style={{ marginTop: 10, width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8 }}>
                        <option value="">— escolher a pessoa —</option>
                        {trabalhadores.map(t => {
                            const n = equipamentos.filter(e => String(e.trabalhador_id) === String(t.id) && e.ativo !== false).length;
                            return <option key={t.id} value={t.id}>{t.nome}{n ? ` (${n})` : ' — sem fichas'}</option>;
                        })}
                    </select>
                )}

                {ambito !== 'filtrados' && (
                    <div style={{ marginTop: 10 }}>
                        <label style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: 600 }}>Categoria</label>
                        <select value={categoria} onChange={e => setCategoria(e.target.value)}
                            style={{ width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8 }}>
                            <option value="todas">Todas</option>
                            {Object.entries(CATEGORIAS).map(([k, c]) => <option key={k} value={k}>{c.icone} {c.plural}</option>)}
                        </select>
                    </div>
                )}

                <div style={{ marginTop: 14 }}>
                    <label style={{ fontSize: '0.78rem', color: '#64748b', fontWeight: 600 }}>Formato</label>
                    <select value={formato} onChange={e => setFormato(e.target.value)}
                        style={{ width: '100%', padding: '8px 10px', border: '1px solid #cbd5e1', borderRadius: 8 }}>
                        <option value="etiqueta">Etiqueta 50×25 mm (etiquetadora)</option>
                        <option value="a4">Folha A4 com 18 etiquetas (para recortar)</option>
                    </select>
                </div>

                <p style={{ marginTop: 14, fontSize: '0.8rem', color: quantos ? '#0f766e' : '#b45309' }}>
                    {quantos ? `${quantos} ficha(s) — as impressas deixam de estar «por etiquetar».` : 'Nada a imprimir nesta seleção.'}
                </p>

                <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
                    <button className="btn-secondary" onClick={onFechar}>Cancelar</button>
                    <button className="btn-primary" onClick={imprimir} disabled={!quantos || !pronto}
                        style={(!quantos || !pronto) ? { opacity: 0.5, cursor: 'not-allowed' } : undefined}>
                        <OrcamentoIcon name="print" fallback="🖨️" /> Imprimir
                    </button>
                </div>
            </div>
        </LiquidDialog>
    );
};

const badgePorEtiquetar = (
    <span className="eq-pill eq-pill--amber" title="A etiqueta QR ainda não foi impressa"
        style={{ padding: '1px 8px', borderRadius: 10, fontSize: '0.72rem', fontWeight: 600, background: '#fffaf0', color: '#c05621', whiteSpace: 'nowrap' }}>
        <OrcamentoIcon name="tag" fallback="🏷️" /> Por etiquetar
    </span>
);

const Equipamentos = ({ categoriaInicial = 'todos' }) => {
    const liquidFeedback = useLiquidFeedback();
    const [equipamentos, setEquipamentos] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingEquipamento, setEditingEquipamento] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [filterProprio, setFilterProprio] = useState('todos');
    const [filterCategoria, setFilterCategoria] = useState(categoriaInicial);
    const mostrarQuimicos = filterCategoria === 'quimicos';
    const [soPorEtiquetar, setSoPorEtiquetar] = useState(false);
    // Pessoa a quem a ficha está afeta: 'todos', 'sem' (sem afetação) ou o id
    const [filterAfeto, setFilterAfeto] = useState('todos');
    // Impressão de etiquetas em lote: null fechado, {} aberto
    const [qrLote, setQrLote] = useState(null);
    const [activeTab, setActiveTab] = useState('basico');
    const [showDL50Modal, setShowDL50Modal] = useState(false);
    // DL50 em lote: as fichas da lista (com os filtros) quando se abriu, ou null
    const [dl50Lote, setDl50Lote] = useState(null);
    const [trabalhadores, setTrabalhadores] = useState([]);
    const [obras, setObras] = useState([]);
    const [viewMode, setViewMode] = useState('list'); // 'list' or 'grid'
    const [qrModal, setQrModal] = useState(null);
    // Documentação de certificação: null fechado, { equipamento } para a ficha
    // de um equipamento, { todos: true } para a vista anual de tudo.
    const [docsModal, setDocsModal] = useState(null);
    const [rmmModal, setRmmModal] = useState(null);

    const [dl50FormData, setDl50FormData] = useState({
        // ... (keep existing dl50FormData)
        equipamento_id: '',
        obra_id: '',
        tecnico_id: '',
        data_verificacao: new Date().toISOString().split('T')[0],
        tipo_verificacao: 'Montagem inicial',
        tipo_maquina: 'Metalomecânica',
        local_verificacao: '',
        proprio_alugado: 'Próprio',
        checklist: {},
        resultado_usavel: true,
        observacoes_finais: '',
        nome_tecnico: '',
        cargo_tecnico: '',
        assinatura_snapshot: ''
    });

    const [formData, setFormData] = useState(FORM_VAZIO);

    useEffect(() => {
        fetchEquipamentos();
        fetchAuxiliarData();
    }, []);

    const fetchAuxiliarData = async () => {
        try {
            const [trabRes, obrasRes] = await Promise.all([
                api.get('/trabalhadores'),
                api.get('/obras')
            ]);
            setTrabalhadores(trabRes.data);
            setObras(obrasRes.data.obras || obrasRes.data);
        } catch (error) {
            console.error('Erro ao buscar dados auxiliares:', error);
        }
    };

    const fetchEquipamentos = async () => {
        try {
            const response = await api.get('/equipamentos');
            setEquipamentos(Array.isArray(response.data) ? response.data : []);
        } catch (error) {
            console.error('Erro ao buscar equipamentos:', error);
            setEquipamentos([]);
        }
    };

    // ... (keep helper functions: handleInputChange, handleImportExcel, handleSubmit, handleOpenDL50, handleDL50Submit, handleEdit, handleDelete, closeModal, handleDownloadTemplate, filteredEquipamentos)

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleImportExcel = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('file', file);

        try {
            const res = await api.post('/equipamentos/import', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            liquidFeedback.notify(`Sucesso! Importados ${res.data.imported} equipamentos.`, { icon: 'check' });
            fetchEquipamentos();
        } catch (error) {
            console.error('Erro ao importar:', error);
            liquidFeedback.notify('Erro ao importar ficheiro Excel');
        } finally {
            e.target.value = null;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingEquipamento) {
                await api.put(`/equipamentos/${editingEquipamento.id}`, formData);
            } else {
                await api.post('/equipamentos', formData);
            }
            fetchEquipamentos();
            closeModal();
        } catch (error) {
            console.error('Erro ao salvar equipamento:', error);
            liquidFeedback.notify('Erro ao salvar equipamento');
        }
    };

    const handleOpenDL50 = (equip) => {
        setDl50FormData(prev => ({
            ...prev,
            equipamento_id: equip.id,
            proprio_alugado: equip.proprio ? 'Próprio' : 'Alugado',
            tipo_maquina: equip.tipo || 'Outro',
            // tudo «C»; num EPI os itens de máquinas vêm «NA», nas outras fichas os de EPI
            checklist: checklistPara(equip, checklistConforme())
        }));
        setShowDL50Modal(true);
    };

    // Save DL50 without generating PDF
    const handleDL50SaveOnly = async (e) => {
        e.preventDefault();
        try {
            await api.post('/dl50', dl50FormData);
            setShowDL50Modal(false);
            fetchEquipamentos();
            liquidFeedback.notify('Verificação DL50 guardada com sucesso!');
        } catch (error) {
            console.error('Erro ao guardar DL50:', error);
            liquidFeedback.notify('Erro ao guardar DL50');
        }
    };

    // Save DL50 AND open PDF (also updates dl50_ultima_verificacao on the equipment)
    const handleDL50SaveAndPDF = async (e) => {
        e.preventDefault();
        try {
            const res = await api.post('/dl50', dl50FormData);
            setShowDL50Modal(false);
            fetchEquipamentos();
            // Download PDF directly (no new tab)
            const pdfRes = await api.get(`/dl50/relatorio/${res.data.id}`, { responseType: 'blob' });
            const blobUrl = window.URL.createObjectURL(new Blob([pdfRes.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', `DL50_${res.data.relatorio_num || res.data.id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('Erro ao guardar DL50:', error);
            liquidFeedback.notify('Erro ao guardar DL50');
        }
    };

    // A última verificação da ficha, em PDF (o relatório mais recente, como no QR)
    const descarregarUltimoDL50 = async (eq) => {
        if (!eq.dl50_ultimo_id) return;
        try {
            const pdfRes = await api.get(`/dl50/relatorio/${eq.dl50_ultimo_id}`, { responseType: 'blob' });
            const nome = `DL50_${eq.dl50_ultimo_num || eq.dl50_ultimo_id}_${eq.nome || ''}`.replace(/[\\/:*?"<>|]+/g, '-');
            descarregarBlob(pdfRes.data, `${nome}.pdf`);
        } catch (error) {
            console.error('Erro ao descarregar o DL50:', error);
            liquidFeedback.notify('Não foi possível descarregar o último relatório DL50.');
        }
    };
    const tituloUltimoDL50 = (eq) => (eq.dl50_ultimo_id
        ? `Descarregar a última verificação DL50 (${eq.dl50_ultimo_num || 's/ nº'}${eq.dl50_ultimo_em ? ` de ${new Date(eq.dl50_ultimo_em).toLocaleDateString('pt-PT')}` : ''})`
        : 'Ainda não há verificação DL50 desta ficha');

    /* Os RMM (fitas, réguas de nível, lasers) não se verificam pelo DL50: a ficha
       do Sistema Integrado (IT.IM.01) é a que lhes serve, e é mensal. Nestas
       fichas a verificação e o último relatório vêm de lá. */
    const ehRmm = (eq) => categoriaDe(eq) === 'rmm';
    const abrirVerificacaoRmm = (eq) => setRmmModal({ equipamentoId: eq.id });
    const tituloVerificacaoRmm = (eq) => `Verificar RMM — ${eq.nome}`;
    const descarregarUltimoRmm = async (eq) => {
        if (!eq.rmm_ultimo_id) return;
        try {
            const pdfRes = await api.get(`/sistema-integrado/rmm/verificacoes/${eq.rmm_ultimo_id}/relatorio`, { responseType: 'blob' });
            const nome = `RMM_${eq.rmm_ultimo_num || eq.rmm_ultimo_id}_${eq.nome || ''}`.replace(/[\\/:*?"<>|]+/g, '-');
            descarregarBlob(pdfRes.data, `${nome}.pdf`);
        } catch (error) {
            console.error('Erro ao descarregar a verificação de RMM:', error);
            liquidFeedback.notify('Não foi possível descarregar a última verificação de RMM.');
        }
    };
    const tituloUltimoRmm = (eq) => (eq.rmm_ultimo_id
        ? `Descarregar a última verificação de RMM (${eq.rmm_ultimo_num || 's/ nº'}${eq.rmm_ultimo_em ? ` de ${new Date(eq.rmm_ultimo_em).toLocaleDateString('pt-PT')}` : ''})`
        : 'Ainda não há verificação de RMM desta ficha');

    const handleEdit = (equipamento) => {
        setEditingEquipamento(equipamento);
        const formatted = { ...equipamento };
        Object.keys(formatted).forEach(key => {
            if (key.includes('data') || key.includes('validad') || key.includes('inspecao') || key.includes('revisao') || key.includes('calibracao') || key.includes('verificacao') || key.includes('_fim')) {
                if (formatted[key]) {
                    formatted[key] = new Date(formatted[key]).toISOString().split('T')[0];
                }
            }
        });
        setFormData(formatted);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        if (await liquidFeedback.confirm('Tem certeza que deseja deletar este equipamento?')) {
            try {
                await api.delete(`/equipamentos/${id}`);
                fetchEquipamentos();
            } catch (error) {
                console.error('Erro ao deletar equipamento:', error);
                liquidFeedback.notify('Erro ao deletar equipamento');
            }
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setEditingEquipamento(null);
        // Formulário completo de novo (o reset parcial deixava "Próprio?" por marcar)
        setFormData(FORM_VAZIO);
        setActiveTab('basico');
    };

    const handleDownloadTemplate = async () => {
        try {
            const response = await api.get('/equipamentos/template', {
                responseType: 'blob'
            });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'template_importacao_equipamentos.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Erro ao descarregar template:', error);
            liquidFeedback.notify('Erro ao descarregar template Excel');
        }
    };

    const listaEquipamentos = Array.isArray(equipamentos) ? equipamentos : [];
    const filteredEquipamentos = listaEquipamentos.filter(eq => {
        const texto = [codigoEquipamento(eq.id), eq.nome, eq.marca, eq.modelo, eq.matricula, eq.n_serie, eq.tipo, eq.registado_por_nome, eq.trabalhador_nome]
            .filter(Boolean).join(' ').toLowerCase();
        const matchesSearch = texto.includes(searchTerm.trim().toLowerCase());
        const matchesProprio = filterProprio === 'todos' ||
            (filterProprio === 'proprio' && eq.proprio) ||
            (filterProprio === 'alugado' && !eq.proprio);
        const matchesCategoria = filterCategoria === 'todos' || categoriaDe(eq) === filterCategoria;
        const matchesEtiqueta = !soPorEtiquetar || porEtiquetar(eq);
        const matchesAfeto = filterAfeto === 'todos'
            || (filterAfeto === 'sem' ? !eq.trabalhador_id : String(eq.trabalhador_id) === String(filterAfeto));
        return matchesSearch && matchesProprio && matchesCategoria && matchesEtiqueta && matchesAfeto;
    });
    const nPorEtiquetar = listaEquipamentos.filter(porEtiquetar).length;
    // DL50 individual de um EPI (arnês, mosquetão, corda, fita): aviso de que a check-list veio adaptada
    const epiDL50 = showDL50Modal ? tiposEpi(listaEquipamentos.find(e => e.id === dl50FormData.equipamento_id)) : [];

    // ---- QR codes ----
    const origin = window.location.origin;
    const qrImgUrl = (eq) => `${api.defaults.baseURL}/equipamentos/${eq.id}/qrcode?base=${encodeURIComponent(origin)}`;
    const publicUrl = (eq) => `${origin}/eq/${eq.qr_token}`;

    const openBlobPdf = (blob) => {
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
    };

    // Mudar a categoria na própria lista. Muda logo no ecrã e volta atrás se o
    // servidor recusar; o aviso diz para onde foi (com o filtro de categoria
    // ativo, a linha sai da vista) e deixa anular.
    const [converterQuimico, setConverterQuimico] = useState(null);
    const [avisoCategoria, setAvisoCategoria] = useState(null); // { texto, anular }
    useEffect(() => {
        if (!avisoCategoria) return undefined;
        const t = setTimeout(() => setAvisoCategoria(null), 8000);
        return () => clearTimeout(t);
    }, [avisoCategoria]);

    const mudarCategoria = async (eq, nova, aAnular = false) => {
        if (nova === 'produto_quimico') { setConverterQuimico(eq); return; }
        const anterior = categoriaDe(eq);
        if (!CATEGORIAS[nova] || nova === anterior) return;
        const aplicar = (cat) => setEquipamentos(prev => prev.map(e => (e.id === eq.id ? { ...e, categoria: cat } : e)));
        aplicar(nova);
        try {
            await api.patch('/equipamentos/categoria', { ids: [eq.id], categoria: nova });
            setAvisoCategoria({
                texto: `«${eq.nome}» ${aAnular ? 'voltou para' : 'passou para'} ${CATEGORIAS[nova].plural}.`,
                anular: aAnular ? null : () => mudarCategoria({ ...eq, categoria: nova }, anterior, true),
            });
        } catch (error) {
            console.error('Erro ao mudar a categoria:', error);
            aplicar(anterior);
            liquidFeedback.notify('Não foi possível mudar a categoria.');
        }
    };

    // ids -> essas fichas; { trabalhador_id } -> as de uma pessoa; {} -> todas as
    // ativas. O formato 'a4' dá a folha 3×6 para recorte, em vez da etiquetadora.
    const handlePrintQr = async (alvo, formato = 'etiqueta') => {
        if (Array.isArray(alvo) && alvo.length === 0) return;
        const corpo = Array.isArray(alvo) ? { ids: alvo } : { ...(alvo || {}) };
        try {
            const res = await api.post('/equipamentos/qrcodes/print',
                { ...corpo, formato, base: origin }, { responseType: 'blob' });
            openBlobPdf(res.data);
            fetchEquipamentos(); // as impressas saem de "Por etiquetar"
        } catch (e) {
            const semQr = e.response?.status === 404;
            liquidFeedback.notify(semQr
                ? 'Nenhum equipamento com QR para imprimir nessa seleção.'
                : 'Erro ao gerar as etiquetas QR. Confirme que a biblioteca de QR (qrcode) está instalada no servidor.');
        }
    };

    const downloadQrPng = (eq) => window.open(`${qrImgUrl(eq)}&download=1`, '_blank');

    return (
        <div className="equipamentos-container">
            {/* Top Bar Uniforme */}
            <div className="top-bar">
                <div className="top-bar-left">
                    <div className="top-bar-title">
                        <h1><OrcamentoIcon name="equipment" fallback="🛠️" /> Equipamentos & Ferramentas</h1>
                        <p>Ficheiros de equipamentos e documentação DL50</p>
                    </div>
                </div>
                {!mostrarQuimicos && <div className="top-bar-actions">
                    <button className="btn-secondary" onClick={handleDownloadTemplate} style={{ backgroundColor: '#edf2f7', color: '#4a5568' }}>
                        <OrcamentoIcon name="download" fallback="📄" /> Template Excel
                    </button>
                    <input
                        type="file"
                        id="import-excel-equip"
                        style={{ display: 'none' }}
                        accept=".xlsx, .xls, .csv"
                        onChange={handleImportExcel}
                    />
                    <button className="btn-secondary" onClick={() => document.getElementById('import-excel-equip').click()}>
                        <OrcamentoIcon name="upload" fallback="📥" /> Importar Excel
                    </button>
                    <button className="btn-secondary" onClick={() => setQrLote({})}
                        title="Imprimir etiquetas QR em lote: as da lista, todas, ou as de uma pessoa">
                        <OrcamentoIcon name="tag" fallback="🏷️" /> Imprimir QR ({filteredEquipamentos.length})
                    </button>
                    <button className="btn-secondary" onClick={() => setDocsModal({ todos: true })}
                        title="Verificações, certificados e manuais em PDF, por ano">
                        <OrcamentoIcon name="document" fallback="📁" /> Documentação
                    </button>
                    {listaEquipamentos.some(ehRmm) && <button className="btn-secondary" onClick={() => setRmmModal({})}><OrcamentoIcon name="ruler" fallback="📏" /> Verificar RMM em lote</button>}
                    <button className="btn-primary" onClick={() => setShowModal(true)}>+ Novo Equipamento</button>
                </div>}
            </div>

            {/* Conteúdo da Página */}
            <div className="page-content">
                {!mostrarQuimicos && <div className="shared-search">
                    <input
                        type="text"
                        placeholder="Pesquisar por ID, nome, marca, nº de série, matrícula, quem registou..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>}

                <div className="eq-toolbar">
                    <div className="eq-toolbar-filters">
                        {!mostrarQuimicos && <div className="shared-subnav eq-toolbar-segment" role="group" aria-label="Propriedade">
                            <button type="button" className={`shared-subnav-btn ${filterProprio === 'todos' ? 'active' : ''}`} aria-pressed={filterProprio === 'todos'} onClick={() => setFilterProprio('todos')}>Todos</button>
                            <button type="button" className={`shared-subnav-btn ${filterProprio === 'proprio' ? 'active' : ''}`} aria-pressed={filterProprio === 'proprio'} onClick={() => setFilterProprio('proprio')}>Próprio</button>
                            <button type="button" className={`shared-subnav-btn ${filterProprio === 'alugado' ? 'active' : ''}`} aria-pressed={filterProprio === 'alugado'} onClick={() => setFilterProprio('alugado')}>Alugado</button>
                        </div>}

                        <div className="eq-toolbar-categories">
                            <div className="shared-subnav eq-toolbar-segment" role="group" aria-label="Categoria">
                                <button type="button" className={`shared-subnav-btn ${filterCategoria === 'todos' ? 'active' : ''}`} aria-pressed={filterCategoria === 'todos'} onClick={() => setFilterCategoria('todos')}>Todas</button>
                                {Object.entries(CATEGORIAS).map(([k, c]) => (
                                    <button type="button" key={k} className={`shared-subnav-btn ${filterCategoria === k ? 'active' : ''}`} aria-pressed={filterCategoria === k} onClick={() => setFilterCategoria(k)}>
                                        <OrcamentoIcon name={k === 'ferramenta' ? 'maintenance' : k === 'rmm' ? 'ruler' : 'equipment'} fallback={c.icone} /> {c.plural}
                                    </button>
                                ))}
                            </div>
                            <div className="shared-subnav eq-toolbar-segment eq-chemicals-shortcut">
                                <button type="button" className={`shared-subnav-btn ${mostrarQuimicos ? 'active' : ''}`} aria-pressed={mostrarQuimicos} onClick={() => setFilterCategoria('quimicos')} title="Consultar e registar produtos químicos e aceder às suas fichas">
                                    <OrcamentoIcon name="test" fallback="⚗️" /> Produtos químicos
                                </button>
                            </div>
                        </div>

                        {!mostrarQuimicos && <div className={`eq-person-filter ${filterAfeto !== 'todos' ? 'is-filtered' : ''}`}>
                            <span className="eq-person-filter-icon" aria-hidden="true"><OrcamentoIcon name="users" fallback="👤" /></span>
                            <select aria-label="Filtrar por pessoa afeta" value={filterAfeto} onChange={e => setFilterAfeto(e.target.value)} title="Filtrar pelas fichas afetas a uma pessoa">
                                <option value="todos">Todas as pessoas</option>
                                <option value="sem">— sem pessoa afeta ({listaEquipamentos.filter(e => !e.trabalhador_id).length}) —</option>
                                {trabalhadores.map(t => {
                                    const n = listaEquipamentos.filter(e => String(e.trabalhador_id) === String(t.id)).length;
                                    return n ? <option key={t.id} value={t.id}>{t.nome} ({n})</option> : null;
                                })}
                            </select>
                        </div>}

                        {!mostrarQuimicos && (nPorEtiquetar > 0 || soPorEtiquetar) && (
                            <div className="shared-subnav eq-toolbar-segment eq-pending-filter">
                                <button type="button" className={`shared-subnav-btn ${soPorEtiquetar ? 'active' : ''}`} aria-pressed={soPorEtiquetar}
                                    onClick={() => setSoPorEtiquetar(v => !v)}
                                    title="Fichas novas cuja etiqueta QR ainda não foi impressa — filtre e use «Imprimir QR»">
                                    <OrcamentoIcon name="tag" fallback="🏷️" /> Por etiquetar <span className="eq-toolbar-count">{nPorEtiquetar}</span>
                                </button>
                            </div>
                        )}
                    </div>

                    {!mostrarQuimicos && <div className="shared-subnav eq-toolbar-segment eq-view-toggle" role="group" aria-label="Modo de visualização">
                        <button type="button" className={`shared-subnav-btn ${viewMode === 'grid' ? 'active' : ''}`} aria-pressed={viewMode === 'grid'} onClick={() => setViewMode('grid')} title="Vista de cartões">
                            <OrcamentoIcon name="dashboard" fallback="🏗️" /> Grelha
                        </button>
                        <button type="button" className={`shared-subnav-btn ${viewMode === 'list' ? 'active' : ''}`} aria-pressed={viewMode === 'list'} onClick={() => setViewMode('list')} title="Vista de lista">
                            <OrcamentoIcon name="list" fallback="📋" /> Lista
                        </button>
                    </div>}
                </div>

                {mostrarQuimicos ? (
                    <div className="pq-internal-page"><ProdutosQuimicosPainel interno /></div>
                ) : <>
                {avisoCategoria && (
                    <div role="status" style={{ display: 'flex', alignItems: 'center', gap: 12, background: '#f0fff4', border: '1px solid #9ae6b4', color: '#22543d', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: '0.88rem' }}>
                        <span style={{ flex: 1 }}><OrcamentoIcon name="check" fallback="✅" /> <LiquidText>{avisoCategoria.texto}</LiquidText></span>
                        {avisoCategoria.anular && (
                            <button onClick={() => { const anular = avisoCategoria.anular; setAvisoCategoria(null); anular(); }}
                                style={{ border: '1px solid #9ae6b4', background: '#fff', color: '#22543d', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', fontWeight: 600 }}>
                                Anular
                            </button>
                        )}
                        <button onClick={() => setAvisoCategoria(null)} aria-label="Fechar aviso"
                            style={{ border: 'none', background: 'transparent', color: '#22543d', cursor: 'pointer', fontSize: '1rem' }}><LiquidText>✕</LiquidText></button>
                    </div>
                )}

                {filteredEquipamentos.length === 0 ? (
                    <div className="equipamentos-table-container">
                        <div style={{ padding: '40px', textAlign: 'center', color: '#718096' }}>
                            {soPorEtiquetar && nPorEtiquetar === 0 ? <><OrcamentoIcon name="check" fallback="✅" /> Não há fichas por etiquetar.</> : 'Nenhum equipamento encontrado'}
                        </div>
                    </div>
                ) : (
                    <>
                        {viewMode === 'list' ? (
                            <div className="equipamentos-table-container">
                                <table className="standard-table equipamentos-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Nome / Marca</th>
                                            <th>Matrícula / Série</th>
                                            <th>Tipo</th>
                                            <th>Categoria</th>
                                            <th>Verificação</th>
                                            <th>Resultado</th>
                                            <th>Propriedade</th>
                                            <th>
                                                <div className="eq-bulk-actions">
                                                    <span>Ações</span>
                                                    <button className="eq-bulk-button" type="button" onClick={() => setDl50Lote(filteredEquipamentos.filter(e => !ehRmm(e)))}
                                                        title="DL50 de todas as fichas desta lista (com os filtros aplicados): a mesma data e técnico, tudo pré-marcado «Conforme». Os RMM ficam de fora — a ficha deles é a do Sistema Integrado."
                                                        disabled={!filteredEquipamentos.some(e => !ehRmm(e))}>
                                                        <OrcamentoIcon name="dl50" fallback="📋" /> DL50 ({filteredEquipamentos.filter(e => !ehRmm(e)).length})
                                                    </button>
                                                    <button className="eq-bulk-button" type="button" onClick={() => setQrLote({ apenasFiltrados: true })}
                                                        disabled={!filteredEquipamentos.length}
                                                        title="Imprimir as etiquetas de todas as fichas desta lista, com a pesquisa e os filtros aplicados">
                                                        <OrcamentoIcon name="tag" fallback="🏷️" /> Etiquetas ({filteredEquipamentos.length})
                                                    </button>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredEquipamentos.map(eq => (
                                            <tr key={eq.id}>
                                                <td className="eq-code">{codigoEquipamento(eq.id)}</td>
                                                <td>
                                                    <div style={{ fontWeight: '600', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                                        {eq.nome}
                                                        {porEtiquetar(eq) && badgePorEtiquetar}
                                                    </div>
                                                    <div style={{ fontSize: '0.8rem', color: '#666' }}>{eq.marca} {eq.modelo}</div>
                                                    {eq.trabalhador_nome && (
                                                        <div style={{ fontSize: '0.78rem', color: '#4c51bf' }} title="Pessoa a quem esta ficha está afeta">
                                                            <OrcamentoIcon name="users" fallback="👤" /> {eq.trabalhador_nome}
                                                        </div>
                                                    )}

                                                </td>
                                                <td>
                                                    <div>{eq.matricula || '-'}</div>
                                                    <div style={{ fontSize: '0.8rem', color: '#666' }}>{eq.n_serie}</div>
                                                </td>
                                                <td>{eq.tipo}</td>
                                                <td><SeletorCategoria eq={eq} onMudar={mudarCategoria} /></td>
                                                <td>
                                                    {ehRmm(eq) ? (
                                                        <span title="Verificação mensal do Sistema Integrado (IT.IM.01)" style={{ fontSize: '0.82rem', color: '#6b46c1' }}>
                                                            <OrcamentoIcon name="ruler" fallback="📏" /> mensal{eq.rmm_ultimo_em ? ` · ${new Date(eq.rmm_ultimo_em).toLocaleDateString('pt-PT')}` : ''}
                                                        </span>
                                                    ) : (
                                                        <span style={{ color: new Date(eq.dl50_proxima_verificacao) < new Date() ? 'red' : 'inherit' }}>
                                                            {eq.dl50_proxima_verificacao ? new Date(eq.dl50_proxima_verificacao).toLocaleDateString('pt-PT') : '-'}
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    {ehRmm(eq) ? (
                                                        <span className={`eq-pill ${eq.rmm_id ? 'eq-pill--violet' : 'eq-pill--amber'}`} style={{
                                                            padding: '2px 8px', borderRadius: 4, fontSize: '0.8rem',
                                                            backgroundColor: eq.rmm_id ? '#faf5ff' : '#fffaf0',
                                                            color: eq.rmm_id ? '#6b46c1' : '#c05621',
                                                        }} title={eq.rmm_id ? 'Cruzado com o Sistema Integrado' : 'Falta criar o RMM no Sistema Integrado'}>
                                                            {eq.rmm_codigo || 'Por cruzar'}
                                                        </span>
                                                    ) : (
                                                        <span className={`eq-pill ${eq.dl50_resultado === 'Conforme' ? 'eq-pill--green' : eq.dl50_resultado ? 'eq-pill--red' : 'eq-pill--muted'}`} style={{
                                                            padding: '2px 8px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.8rem',
                                                            backgroundColor: eq.dl50_resultado === 'Conforme' ? '#c6f6d5' : eq.dl50_resultado ? '#fed7d7' : 'transparent',
                                                            color: eq.dl50_resultado === 'Conforme' ? '#22543d' : eq.dl50_resultado ? '#822727' : 'inherit'
                                                        }}>
                                                            {eq.dl50_resultado || '-'}
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    <span className={`badge eq-pill ${eq.proprio ? 'badge-proprio eq-pill--blue' : 'badge-alugado eq-pill--amber'}`}>
                                                        {eq.proprio ? 'Próprio' : 'Alugado'}
                                                    </span>
                                                </td>
                                                <td className="actions-cell eq-actions-cell">
                                                    <div className="eq-row-actions">
                                                    <button className="btn-edit" onClick={() => handleEdit(eq)} title="Editar"><OrcamentoIcon name="edit" fallback="✏️" /></button>
                                                    {ehRmm(eq) ? (
                                                        <>
                                                            <button className="btn-edit" onClick={() => abrirVerificacaoRmm(eq)} title={tituloVerificacaoRmm(eq)}
                                                                style={{ backgroundColor: '#faf5ff' }}><OrcamentoIcon name="ruler" fallback="📏" /></button>
                                                            <button className="btn-edit" onClick={() => descarregarUltimoRmm(eq)} disabled={!eq.rmm_ultimo_id}
                                                                title={tituloUltimoRmm(eq)} aria-label={`Última verificação de RMM de ${eq.nome}`}
                                                                style={{ backgroundColor: '#f0fff4', ...(eq.rmm_ultimo_id ? {} : { opacity: 0.3, cursor: 'not-allowed' }) }}><OrcamentoIcon name="download" fallback="⬇️" /></button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <button className="btn-edit" onClick={() => handleOpenDL50(eq)} title="DL50" style={{ backgroundColor: '#e6fffa' }}><OrcamentoIcon name="dl50" fallback="📋" /></button>
                                                            <button className="btn-edit" onClick={() => descarregarUltimoDL50(eq)} disabled={!eq.dl50_ultimo_id}
                                                                title={tituloUltimoDL50(eq)} aria-label={`Última verificação DL50 de ${eq.nome}`}
                                                                style={{ backgroundColor: '#f0fff4', ...(eq.dl50_ultimo_id ? {} : { opacity: 0.3, cursor: 'not-allowed' }) }}><OrcamentoIcon name="download" fallback="⬇️" /></button>
                                                        </>
                                                    )}
                                                    <button className="btn-edit" onClick={() => setDocsModal({ equipamento: eq })} title="Documentação (PDF)" style={{ backgroundColor: '#fef9c3' }}><OrcamentoIcon name="document" fallback="📁" /></button>
                                                    <button className="btn-edit" onClick={() => setQrModal(eq)} title="QR Code" style={{ backgroundColor: '#eef2ff' }}><OrcamentoIcon name="tag" fallback="🏷️" /></button>
                                                    <button className="btn-delete" onClick={() => handleDelete(eq.id)} title="Deletar"><OrcamentoIcon name="trash" fallback="🗑️" /></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '20px', padding: '10px' }}>
                                {filteredEquipamentos.map(eq => (
                                    <div data-liquid-surface="true"
                                        key={eq.id}
                                        style={{
                                            backgroundColor: 'white',
                                            borderRadius: '10px',
                                            padding: '20px',
                                            boxShadow: '0 2px 5px rgba(0,0,0,0.05)',
                                            border: '1px solid #e2e8f0',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '12px'
                                        }}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                                <div style={{
                                                    width: '45px', height: '45px', borderRadius: '8px',
                                                    background: '#edf2f7', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    fontSize: '22px'
                                                }}>
                                                    <OrcamentoIcon name={categoriaDe(eq) === 'ferramenta' ? 'maintenance' : 'equipment'} fallback={categoriaDe(eq) === 'equipamento' ? '🛠️' : CATEGORIAS[categoriaDe(eq)].icone} />
                                                </div>
                                                <div>
                                                    <div className="eq-code">{codigoEquipamento(eq.id)}</div>
                                                    <h3 style={{ margin: 0, fontSize: '1.05rem', color: '#2d3748' }}>{eq.nome}</h3>
                                                    <span style={{ fontSize: '0.85rem', color: '#718096' }}>{eq.marca} {eq.modelo}</span>
                                                    {porEtiquetar(eq) && (
                                                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
                                                            {badgePorEtiquetar}
                                                        </div>
                                                    )}
                                                    {eq.trabalhador_nome && (
                                                        <div style={{ fontSize: '0.78rem', color: '#4c51bf', marginTop: 4 }} title="Pessoa a quem esta ficha está afeta">
                                                            <OrcamentoIcon name="users" fallback="👤" /> {eq.trabalhador_nome}
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                            <span className={`badge eq-pill ${eq.proprio ? 'badge-proprio eq-pill--blue' : 'badge-alugado eq-pill--amber'}`} style={{ fontSize: '0.75rem', padding: '2px 8px' }}>
                                                {eq.proprio ? 'Próprio' : 'Alugado'}
                                            </span>
                                        </div>

                                        <div data-liquid-surface="true" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '0.85rem', color: '#4a5568', background: '#f8fafc', padding: '10px', borderRadius: '6px' }}>
                                            <div><LiquidText>🆔: </LiquidText><b>{eq.matricula || eq.n_serie || '-'}</b></div>
                                            <div><LiquidText>📂: </LiquidText>{eq.tipo || '-'}</div>
                                            <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', gap: 6 }}>
                                                Categoria: <SeletorCategoria eq={eq} onMudar={mudarCategoria} />
                                            </div>
                                            {ehRmm(eq) ? (
                                                <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', gap: '5px' }}
                                                    title="Os RMM verificam-se pela ficha mensal do Sistema Integrado (IT.IM.01)">
                                                    <OrcamentoIcon name="ruler" fallback="📏" /> RMM:
                                                    <span className={`eq-pill ${eq.rmm_id ? 'eq-pill--violet' : 'eq-pill--amber'}`} style={{ fontWeight: 'bold', color: eq.rmm_id ? '#6b46c1' : '#c05621' }}>
                                                        {eq.rmm_codigo || 'Por cruzar'}
                                                    </span>
                                                    <span style={{ fontSize: '0.75rem', color: '#718096' }}>
                                                        {eq.rmm_ultimo_em
                                                            ? `(última: ${new Date(eq.rmm_ultimo_em).toLocaleDateString('pt-PT')})`
                                                            : '(sem verificação)'}
                                                    </span>
                                                </div>
                                            ) : (
                                                <div style={{ gridColumn: 'span 2', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <OrcamentoIcon name="dl50" fallback="📋" /> DL50:
                                                    <span className={`eq-pill ${eq.dl50_resultado === 'Conforme' ? 'eq-pill--green' : eq.dl50_resultado ? 'eq-pill--red' : 'eq-pill--muted'}`} style={{
                                                        fontWeight: 'bold',
                                                        color: eq.dl50_resultado === 'Conforme' ? '#38a169' : eq.dl50_resultado ? '#e53e3e' : '#a0aec0'
                                                    }}>
                                                        {eq.dl50_resultado || 'Não verificado'}
                                                    </span>
                                                    {eq.dl50_proxima_verificacao && (
                                                        <span style={{ fontSize: '0.75rem', color: new Date(eq.dl50_proxima_verificacao) < new Date() ? 'red' : '#718096' }}>
                                                            ({new Date(eq.dl50_proxima_verificacao).toLocaleDateString()})
                                                        </span>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: 'auto', paddingTop: '10px', borderTop: '1px solid #edf2f7' }}>
                                            {ehRmm(eq) ? (
                                                <>
                                                    <button className="btn-edit" onClick={() => abrirVerificacaoRmm(eq)} title={tituloVerificacaoRmm(eq)}
                                                        style={{ padding: '6px 12px', fontSize: '0.9rem', backgroundColor: '#faf5ff' }}><OrcamentoIcon name="ruler" fallback="📏" /> RMM</button>
                                                    <button className="btn-edit" onClick={() => descarregarUltimoRmm(eq)} disabled={!eq.rmm_ultimo_id}
                                                        title={tituloUltimoRmm(eq)} aria-label={`Última verificação de RMM de ${eq.nome}`}
                                                        style={{ padding: '6px 12px', fontSize: '0.9rem', backgroundColor: '#f0fff4', ...(eq.rmm_ultimo_id ? {} : { opacity: 0.3, cursor: 'not-allowed' }) }}><OrcamentoIcon name="download" fallback="⬇️" /></button>
                                                </>
                                            ) : (<>
                                            <button className="btn-edit" onClick={() => handleOpenDL50(eq)} style={{ padding: '6px 12px', fontSize: '0.9rem', backgroundColor: '#e6fffa' }}><OrcamentoIcon name="dl50" fallback="📋" /> DL50</button>
                                            <button className="btn-edit" onClick={() => descarregarUltimoDL50(eq)} disabled={!eq.dl50_ultimo_id}
                                                title={tituloUltimoDL50(eq)} aria-label={`Última verificação DL50 de ${eq.nome}`}
                                                style={{ padding: '6px 12px', fontSize: '0.9rem', backgroundColor: '#f0fff4', ...(eq.dl50_ultimo_id ? {} : { opacity: 0.3, cursor: 'not-allowed' }) }}><OrcamentoIcon name="download" fallback="⬇️" /></button>
                                            </>)}
                                            <button className="btn-edit" onClick={() => setQrModal(eq)} style={{ padding: '6px 12px', fontSize: '0.9rem', backgroundColor: '#eef2ff' }}><OrcamentoIcon name="tag" fallback="🏷️" /> QR</button>
                                            <button className="btn-edit" onClick={() => handleEdit(eq)} style={{ padding: '6px 12px', fontSize: '0.9rem' }}><OrcamentoIcon name="edit" fallback="✏️" /> Editar</button>
                                            <button aria-label="Apagar" className="btn-delete" onClick={() => handleDelete(eq.id)} style={{ padding: '6px 12px', fontSize: '0.9rem' }}><OrcamentoIcon name="trash" fallback="🗑️" /></button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </>
                )}

                </>}

                {rmmModal && <RmmEquipamentosModal equipamentoId={rmmModal.equipamentoId} onClose={() => setRmmModal(null)} onSaved={fetchEquipamentos} />}
                {showModal && (
                    <LiquidDialog onClose={closeModal} className="modal-overlay" onClick={closeModal}>
                        <div className="equipamento-modal-content eq-editor" onClick={e => e.stopPropagation()}>
                            <div className="modal-header">
                                <div>
                                    <h2><OrcamentoIcon name="equipment" fallback="🛠️" /> {editingEquipamento ? 'Editar Equipamento' : 'Novo Equipamento'}</h2>
                                    <p className="eq-editor-subtitle">{editingEquipamento ? codigoEquipamento(editingEquipamento.id) : 'O ID será atribuído automaticamente'}</p>
                                </div>
                                <button type="button" className="btn-close" aria-label="Fechar" onClick={closeModal}><OrcamentoIcon name="close" fallback="✕" /></button>
                            </div>
                            <div className="modal-tabs">
                                <button className={`tab-btn ${activeTab === 'basico' ? 'active' : ''}`} aria-pressed={activeTab === 'basico'} onClick={() => setActiveTab('basico')}><OrcamentoIcon name="document" fallback="📝" /> Básico</button>
                                <button className={`tab-btn ${activeTab === 'cert' ? 'active' : ''}`} aria-pressed={activeTab === 'cert'} onClick={() => setActiveTab('cert')}><OrcamentoIcon name="document" fallback="🎓" /> Certificações</button>
                                <button className={`tab-btn ${activeTab === 'manut' ? 'active' : ''}`} aria-pressed={activeTab === 'manut'} onClick={() => setActiveTab('manut')}><OrcamentoIcon name="maintenance" fallback="🔧" /> Manut./DL50</button>
                                <button className={`tab-btn ${activeTab === 'seguro' ? 'active' : ''}`} aria-pressed={activeTab === 'seguro'} onClick={() => setActiveTab('seguro')}><OrcamentoIcon name="check" fallback="🛡️" /> Seguro/Obs</button>
                            </div>
                            <form onSubmit={handleSubmit} className="equipamento-form">
                                <div className="form-body">
                                    {activeTab === 'basico' && (
                                        <div className="form-section">
                                            <h3>Informações Básicas</h3>
                                            {editingEquipamento && (editingEquipamento.registado_por_nome || editingEquipamento.qr_impresso_em) && (
                                                <div className="eq-editor-history">
                                                    {editingEquipamento.registado_por_nome && <p><OrcamentoIcon name="users" fallback="👤" /> Registado por {editingEquipamento.registado_por_nome}{editingEquipamento.criado_em ? ` a ${fmtDataHora(editingEquipamento.criado_em)}` : ''}</p>}
                                                    {(editingEquipamento.qr_impresso_em || porEtiquetar(editingEquipamento)) && <p><OrcamentoIcon name="tag" fallback="🏷️" /> {editingEquipamento.qr_impresso_em ? `Etiqueta QR impressa a ${fmtDataHora(editingEquipamento.qr_impresso_em)}` : 'Etiqueta QR por imprimir'}</p>}
                                                </div>
                                            )}
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Nome / Designação *</label>
                                                    <input type="text" name="nome" value={formData.nome || ''} onChange={handleInputChange} required />
                                                </div>
                                                <div className="form-group">
                                                    <label>Categoria</label>
                                                    <select name="categoria" value={CATEGORIAS[formData.categoria] ? formData.categoria : 'equipamento'} onChange={handleInputChange}>
                                                        {Object.entries(CATEGORIAS).map(([k, c]) => (
                                                            <option key={k} value={k}>{k === 'rmm' ? 'RMM (equip. de medição)' : c.label}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Tipo</label>
                                                    <input type="text" name="tipo" value={formData.tipo || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Marca</label>
                                                    <input type="text" name="marca" value={formData.marca || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Modelo</label>
                                                    <input type="text" name="modelo" value={formData.modelo || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Nº Série</label>
                                                    <input type="text" name="n_serie" value={formData.n_serie || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Matrícula</label>
                                                    <input type="text" name="matricula" value={formData.matricula || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Afeto a (pessoa)</label>
                                                    <select name="trabalhador_id" value={formData.trabalhador_id || ''} onChange={handleInputChange}>
                                                        <option value="">— sem pessoa afeta —</option>
                                                        {trabalhadores.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                                                    </select>
                                                    <small style={{ color: '#94a3b8' }}>Quem tem o equipamento. Serve para imprimir as etiquetas QR por pessoa.</small>
                                                </div>
                                                <div className="form-group">
                                                    <label>Nº de etiquetas QR (peças)</label>
                                                    <input type="number" name="qr_etiquetas" min="1" max="100" value={formData.qr_etiquetas || 1} onChange={handleInputChange} />
                                                    <small style={{ color: '#94a3b8' }}>Para andaimes/conjuntos: imprime o mesmo QR N vezes (1 por peça).</small>
                                                </div>
                                                <div className="form-group">
                                                    <label>Ano Fabrico</label>
                                                    <input type="number" name="ano" value={formData.ano || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group checkbox-group">
                                                    <label>
                                                        <input type="checkbox" name="proprio" checked={formData.proprio} onChange={handleInputChange} />
                                                        <span>Próprio?</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'cert' && (
                                        <div className="form-section">
                                            <h3>Certificações e Formação</h3>
                                            <div className="form-grid">
                                                <div className="form-group checkbox-group">
                                                    <label>
                                                        <input type="checkbox" name="manual_instrucoes" checked={formData.manual_instrucoes} onChange={handleInputChange} />
                                                        <span>Manual de Instruções em PT</span>
                                                    </label>
                                                </div>
                                                <div className="form-group checkbox-group">
                                                    <label>
                                                        <input type="checkbox" name="marcacao_ce" checked={formData.marcacao_ce} onChange={handleInputChange} />
                                                        <span>Certificado / Declaração CE</span>
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label>Certificado Tipo</label>
                                                    <input type="text" name="certificado_tipo" value={formData.certificado_tipo || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Horas Formação</label>
                                                    <input type="number" step="0.1" name="formacao_horas" value={formData.formacao_horas || ''} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'manut' && (
                                        <div className="form-section">
                                            <h3><OrcamentoIcon name="maintenance" fallback="🔧" /> Manutenção e Calibração</h3>
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Última Revisão (Data)</label>
                                                    <input type="date" name="ultima_revisao_data" value={formData.ultima_revisao_data || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Última Revisão (N.º Horas)</label>
                                                    <input type="number" name="ultima_revisao_horas" value={formData.ultima_revisao_horas || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Próxima Revisão (Data)</label>
                                                    <input type="date" name="proxima_revisao_data" value={formData.proxima_revisao_data || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Próxima Revisão (Horas)</label>
                                                    <input type="number" name="proxima_revisao_horas" value={formData.proxima_revisao_horas || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Última Calibração (Data)</label>
                                                    <input type="date" name="ultima_calibracao" value={formData.ultima_calibracao || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Próxima Calibração (Data)</label>
                                                    <input type="date" name="proxima_calibracao" value={formData.proxima_calibracao || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group" style={{ opacity: 0.8 }}>
                                                    <label>Última Verificação DL50</label>
                                                    <input type="date" name="dl50_ultima_verificacao" value={formData.dl50_ultima_verificacao || ''} readOnly style={{ background: '#f8fafc' }} />
                                                </div>
                                                <div className="form-group" style={{ borderLeft: '3px solid #3182ce', paddingLeft: '10px' }}>
                                                    <label style={{ color: '#3182ce', fontWeight: 'bold' }}>Próxima Verificação DL50</label>
                                                    <input type="date" name="dl50_proxima_verificacao" value={formData.dl50_proxima_verificacao || ''} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'seguro' && (
                                        <div className="form-section">
                                            <h3><OrcamentoIcon name="check" fallback="🛡️" /> Seguro e Observações</h3>
                                            <div className="form-grid">
                                                <div className="form-group">
                                                    <label>Certificado Seguro</label>
                                                    <input type="text" name="certificado_seguro" value={formData.certificado_seguro || ''} onChange={handleInputChange} />
                                                </div>
                                                <div className="form-group checkbox-group">
                                                    <label>
                                                        <input type="checkbox" name="contra_terceiros" checked={formData.contra_terceiros} onChange={handleInputChange} />
                                                        <span>Contra Terceiros</span>
                                                    </label>
                                                </div>
                                                <div className="form-group full-width">
                                                    <label>Observações</label>
                                                    <textarea name="observacoes" value={formData.observacoes || ''} onChange={handleInputChange} rows="4"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn-cancel" onClick={closeModal}>Cancelar</button>
                                    <button type="submit" className="btn-submit"><OrcamentoIcon name="save" fallback="💾" /> {editingEquipamento ? 'Atualizar' : 'Criar'}</button>
                                </div>
                            </form>
                        </div>
                    </LiquidDialog>
                )}

                {showDL50Modal && (
                    <LiquidDialog onClose={() => setShowDL50Modal(false)} className="modal-overlay" onClick={() => setShowDL50Modal(false)}>
                        <div className="equipamento-modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '1000px' }}>
                            <div className="modal-header">
                                <h2>Relatório de Verificação DL 50/2005 — {codigoEquipamento(dl50FormData.equipamento_id)}</h2>
                                <button className="btn-close" onClick={() => setShowDL50Modal(false)}><LiquidText>✕</LiquidText></button>
                            </div>
                            <form onSubmit={(e) => e.preventDefault()} className="equipamento-form">
                                <div className="form-body">
                                    <div data-liquid-surface="true" style={{ background: '#f8fafc', padding: '20px', borderRadius: '8px', marginBottom: '25px', border: '1px solid #e2e8f0' }}>
                                        <h3 style={{ margin: '0 0 15px 0', fontSize: '1rem', color: '#2b6cb0' }}><OrcamentoIcon name="document" fallback="📋" /> Identificação da Verificação</h3>
                                        <div className="form-grid">
                                            <div className="form-group">
                                                <label>Técnico Resp. *</label>
                                                <select
                                                    required
                                                    value={dl50FormData.tecnico_id}
                                                    onChange={(e) => {
                                                        const t = trabalhadores.find(x => x.id === parseInt(e.target.value));
                                                        setDl50FormData({ ...dl50FormData, tecnico_id: e.target.value, nome_tecnico: t?.nome, cargo_tecnico: t?.categoria_profissional, assinatura_snapshot: t?.assinatura_url });
                                                    }}
                                                >
                                                    <option value="">Selecione...</option>
                                                    {trabalhadores.map(t => <option key={t.id} value={t.id}>{t.nome}</option>)}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Obra / Local</label>
                                                <select value={dl50FormData.obra_id} onChange={(e) => setDl50FormData({ ...dl50FormData, obra_id: e.target.value })}>
                                                    <option value="">Nenhuma / Outra</option>
                                                    {obras.map(o => <option key={o.id} value={o.id}>{o.posicao}</option>)}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label>Data Verificação</label>
                                                <input type="date" value={dl50FormData.data_verificacao} onChange={(e) => setDl50FormData({ ...dl50FormData, data_verificacao: e.target.value })} />
                                            </div>
                                        </div>
                                    </div>

                                    {epiDL50.length > 0 && (
                                        <div style={{ background: '#fffaf0', border: '1px solid #fbd38d', color: '#9c4221', borderRadius: 8, padding: '8px 12px', marginBottom: 12, fontSize: '0.85rem' }}>
                                            <OrcamentoIcon name="shield" fallback="🦺" /> <b>EPI contra quedas ({epiDL50.map(t => t.label).join(', ')})</b>: vêm marcados os itens de EPI deste tipo (fim da lista); os de máquinas (1 a 20) vêm «NA».
                                        </div>
                                    )}
                                    <ChecklistDL50 checklist={dl50FormData.checklist} onChange={(checklist) => setDl50FormData(prev => ({ ...prev, checklist }))} />

                                    <div className="form-section" style={{ marginTop: '20px', borderBottom: 'none' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <input type="checkbox" checked={dl50FormData.resultado_usavel} onChange={(e) => setDl50FormData({ ...dl50FormData, resultado_usavel: e.target.checked })} />
                                            <b>EQUIPAMENTO APTO PARA UTILIZAÇÃO?</b>
                                        </label>
                                        <textarea placeholder="Observações finais..." rows="2" style={{ marginTop: '10px', width: '100%' }} value={dl50FormData.observacoes_finais} onChange={(e) => setDl50FormData({ ...dl50FormData, observacoes_finais: e.target.value })}></textarea>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn-cancel" onClick={() => setShowDL50Modal(false)}>Cancelar</button>
                                    <button
                                        type="button"
                                        className="btn-secondary"
                                        onClick={handleDL50SaveOnly}
                                    >
                                        <OrcamentoIcon name="save" fallback="💾" /> Gravar
                                    </button>
                                    <button
                                        type="button"
                                        className="btn-submit"
                                        style={{ background: '#48bb78' }}
                                        onClick={handleDL50SaveAndPDF}
                                    >
                                        <OrcamentoIcon name="document" fallback="📄" /> Gravar e Gerar PDF
                                    </button>
                                </div>
                            </form>
                        </div>
                    </LiquidDialog>
                )}

                {dl50Lote && (
                    <DL50LoteModal
                        equipamentos={dl50Lote}
                        trabalhadores={trabalhadores}
                        obras={obras}
                        onFechar={() => setDl50Lote(null)}
                        onGravado={() => { setDl50Lote(null); fetchEquipamentos(); }}
                    />
                )}

                {qrLote && (
                    <QrLoteModal
                        apenasFiltrados={qrLote.apenasFiltrados}
                        filtrados={filteredEquipamentos}
                        equipamentos={listaEquipamentos}
                        trabalhadores={trabalhadores}
                        onImprimir={handlePrintQr}
                        onFechar={() => setQrLote(null)} />
                )}

                {qrModal && (
                    <LiquidDialog onClose={() => setQrModal(null)} onClick={() => setQrModal(null)}
                        style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16 }}>
                        <div data-liquid-surface="true" onClick={e => e.stopPropagation()}
                            style={{ background: '#fff', borderRadius: 14, padding: 24, width: '100%', maxWidth: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.3)', textAlign: 'center' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                                <h3 style={{ margin: 0, fontSize: '1.05rem', textAlign: 'left' }}><OrcamentoIcon name="tag" fallback="🏷️" /> {codigoEquipamento(qrModal.id)} — {qrModal.nome}</h3>
                                <button onClick={() => setQrModal(null)} style={{ border: 'none', background: 'transparent', fontSize: '1.2rem', cursor: 'pointer', color: '#64748b' }}><LiquidText>✕</LiquidText></button>
                            </div>
                            <div data-liquid-surface="true" style={{ background: '#fff', padding: 10, display: 'inline-block', border: '1px solid #e2e8f0', borderRadius: 10 }}>
                                <img src={qrImgUrl(qrModal)} alt="QR code" width={240} height={240} style={{ display: 'block' }} />
                            </div>
                            <div style={{ fontSize: '0.85rem', color: '#475569', marginTop: 10 }}>
                                {qrModal.n_serie || qrModal.matricula || ''}
                                <br />Última verificação: {dataVerificacaoEquipamento(qrModal)}
                            </div>
                            <div style={{ fontSize: '0.72rem', color: '#94a3b8', wordBreak: 'break-all', marginTop: 4 }}>
                                {publicUrl(qrModal)}
                            </div>
                            <div style={{ fontSize: '0.78rem', color: '#64748b', margin: '10px 0 14px', lineHeight: 1.4 }}>
                                Ao ler com o telemóvel abre a página do equipamento com o último relatório DL50 e as datas de manutenção.
                                {qrModal.qr_etiquetas > 1 && <><br /><b>Imprime {qrModal.qr_etiquetas} etiquetas</b> (peças) com este mesmo QR.</>}
                            </div>
                            <div data-liquid-actions="true" style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
                                <button className="btn-secondary" onClick={() => downloadQrPng(qrModal)}><OrcamentoIcon name="download" fallback="⬇️" /> PNG</button>
                                <button className="btn-secondary" onClick={() => handlePrintQr([qrModal.id])}><OrcamentoIcon name="print" fallback="🖨️" /> Imprimir etiqueta</button>
                                <button className="btn-primary" onClick={() => setQrModal(null)}>Fechar</button>
                            </div>
                        </div>
                    </LiquidDialog>
                )}

                {/* Documentação de equipamentos e ferramentas — o local, dentro da
                    aplicação, onde ficam as verificações e restante documentação
                    em PDF (requisito da auditoria de 2025). */}
                {converterQuimico && <EquipamentoProdutoQuimicoModal equipamento={converterQuimico} onClose={() => setConverterQuimico(null)} onSaved={() => { setConverterQuimico(null); fetchEquipamentos(); setFilterCategoria('quimicos'); }} />}
                {docsModal && (
                    <LiquidDialog onClose={() => setDocsModal(null)} className="modal-overlay" onClick={() => setDocsModal(null)}
                        style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '32px 16px', overflowY: 'auto' }}>
                        <div className="equipment-dialog equipment-documents-dialog" onClick={(e) => e.stopPropagation()}>
                            <div className="equipment-dialog-header">
                                <div>
                                    <h3><OrcamentoIcon name="document" fallback="📁" /> Documentação</h3>
                                    <p>{docsModal.equipamento?.nome || 'Equipamentos e ferramentas · Verificações, certificados e manuais'}</p>
                                </div>
                                <button type="button" className="equipment-dialog-close" aria-label="Fechar documentação" onClick={() => setDocsModal(null)}><OrcamentoIcon name="close" fallback="✕" /></button>
                            </div>
                            <DocumentosCertificacao
                                equipamentoId={docsModal.equipamento ? docsModal.equipamento.id : null}
                                equipamentoNome={docsModal.equipamento ? docsModal.equipamento.nome : null}
                            />
                        </div>
                    </LiquidDialog>
                )}
            </div>
        </div>
    );
};

export default Equipamentos;
